/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PetTypeEnum = (typeof PetTypeEnum)[keyof typeof PetTypeEnum];

export const PetTypeEnum = {
  dog: 'dog',
  cat: 'cat',
} as const;
